import clsx from "clsx";
import type { FC } from "react";

import type { BlockType } from "../../../shared/types/worksheet";
import { BLOCK_TYPE_TO_ICON } from "../AddElement";

import { t } from "i18n/i18n";
import { Card } from "mds/components/Card";
import { IconText } from "mds/components/IconText";
import { useAppSelector } from "store/index";
import { selectIsTimeline } from "store/selectors";

type BlockResponsesHeaderProps = {
  blockType: BlockType["t"];
  doneCount: number;
  totalCount: number;
  sticky?: boolean;
  titleOnly?: boolean;
};

export const BlockResponsesHeader: FC<BlockResponsesHeaderProps> = ({
  blockType,
  titleOnly,
  doneCount,
  totalCount,
  sticky = true,
}) => {
  const isTimeline = useAppSelector(selectIsTimeline);
  const Icon = BLOCK_TYPE_TO_ICON[blockType];

  const title = t(`fields.headers.${blockType}`);
  const progressText = t("presentation_aggregates.made_progress", {
    doneCount,
    count: totalCount,
  });

  const text = titleOnly ? title : `${title}: ${progressText}`;

  // The extra div is a bit of a CSS hack to get padding to appear below the sticky header.
  return (
    <div
      className={clsx(
        "z-10 flex flex-col bg-white",
        sticky && "sticky",
        sticky && !isTimeline && "top-0",
        sticky && isTimeline && "top-[199px]",
      )}
    >
      <Card className="body-s-bold page-block-width mx-auto" kind="blue">
        <IconText iconStart={<Icon />} text={text} />
      </Card>
      <div className="h-[16px] w-full" />
    </div>
  );
};
